
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 40 23","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"40","height":"23","data-name":"Vector Smart Object","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAXCAQAAADT28WeAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkBwcLGiWZitbgAAADFUlEQVQ4y5WVb0yVZRjGfwcIOAZmiQpJsxxiSMacrkAza4OWtTEmg9Ucm27Swv65uZVtWRtrjQ9WhmuRa4Urllop60PFYjOtBjWnGeyUUVsL6BCiCUEc49SvDweR/nCE5/7yvNd77Xrv97rv534CMq2VSCHFFHAjmcwmkT8Yoo9OOviY40wSCUxDcBGPsJlkjvAF3/AjQ0RJZjY3kE8Rt3OOJurpGWcbP2b5glFbLDNZxDXutN7XfN6HzRQx6P1+7qi1MUb8DLP5gCS28skEspTbyCKJYb6nleEJvJQ9dHMvg/GySzPk+wa93F/E4mrb/MykeJTnPGXqNOVikt0+OvXrgAOWzkAOscbOpH+5FiCHleSxgGuZy4Ns4Gf6KeMozwDZNNDLY0S4kpe5iq2ECVBLIY9zEkglf3JRbqGKcuZzmlP0cIYLJDCPheSznBT2s5cniLKY/dRSx3rCjFBOJa9wmHXksYQOEi8mu8qPjHrQCtPFBJdabJlrXShiqnfb6LBaZZnnvdkRS8xxzNWedodBw1b7rmHPxOSeNOrrXjfhRamHbPcr23zTFRNohrsc80U/VN8W8Vn1pEGxwj/t9y1bYvCgJdO0vch+3zBr4nmBieO7a8w0bDUWG3H1DCqZ629u/B88xWY7TMZWd82wObbb+Z8jsMmQ33q9BIywkfeAFDYT4hgQoJK/eAeAdeSxj1HgJu7kAP3ASo6zgwukk0ga2SyhgF72spsRQD1vltholxHXiNv8xQFrxDsc8QdfFbMdNGS7CV5hp3rEZpttco87rTDvUrY4ZJ8vucyoy9ztUdMc8D43GXaW7dZZ4Ji5NtjiHAcsd4ujavpUhmC7jUbscp+Y6a+GPGGCSX5tyLNmiE1+Z8RV4nb7POthe6Z2GJ/yU9dabYqIeT7kPBHnW2PueFtvsWj8fFda4UEb4gnO9ZwPzKDGGxwd/9AUgniXw9aZMQ2xOT5txKp4nNhwKKCeQlppo4teholOmsUXmyOHWykhxDaOxRvyl6bNcu5hBYtZRJD0f3B+Z4RufuIELXx5uRvtbxtaM5/Zp7geAAAAAElFTkSuQmCC"}})])
          )
        }
      }
    